import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/index.css";

console.log("@@럭스로보 주차통합 시스템 맵뷰 입니다")

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
